// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"iOeKd","content":"_21FD8","title":"_2lPt_","list-items":"Fp7nm"};